/* export const BASE_URL = "http://127.0.0.1:8000/";
export const NODE_URL = "http://127.0.0.1:4022/v1/"; */

export const GOOGLE_CLIENT = process.env.REACT_APP_GOOGLE_CLIENT;

// for testing Prod (Comment when pushing to staging server)
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const NODE_URL = process.env.REACT_APP_NODE_URL;
export const NODE_URL_V2 = process.env.REACT_APP_NODE_URL_V2;
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;

export const LOGIN_URL = `${NODE_URL}auth/login`;
export const SIGNUP_URL = `${NODE_URL}auth/signup`;
export const SIGNUP_URL_GOOGLE = `${NODE_URL}auth/google-signup`;
export const VERIFY_OTP = `${NODE_URL}auth/verify-otp`;
export const VERIFY_RESET_OTP = `${NODE_URL}auth/verify-reset-otp`;
export const FORGET_PASS_URL = `${NODE_URL}auth/request-password-reset`;
export const LaunchOrg = `${NODE_URL}company/org/launch`;
export const VALID_TOKEN_URL = `${BASE_URL}api/custom-password-reset-url/`;
export const RESET_PASS_URL = `${NODE_URL}auth/reset-password`;
export const LOGOUT_URL = `${NODE_URL}auth/logout`;
export const REFRESH_TOKEN_URL = `${NODE_URL}auth/refresh-token`;
export const FETCH_USER_PROFILE = `${NODE_URL}user/fetch/self`;

// export const ALL_USER = `${BASE_URL}api/users/get_all_users`;
export const ALL_USER = `${NODE_URL}user/get-all-user`;
export const EDIT_PROFILE = `${BASE_URL}api/company/edit_profile`;
export const SAVE_BILLING = `${BASE_URL}api/company/save_billing`;
export const SAVE_CONTACT = `${BASE_URL}api/company/save_contact_person`;
export const SAVE_ADDRESS = `${BASE_URL}api/company/store_address`;
export const CHARTS_OF_ACCOUNTS = `${BASE_URL}api/charts_of_accounts`;
export const CHART_OF_ACCOUNTS = `${NODE_URL}accounts/get-all-coa`;

export const COA_ALL_LEVELS_2 = `${NODE_URL}accounts/get-all-level2-coa`;
export const DETAIL_TYPES = `${NODE_URL}accounts/detail-types`;
export const POST_COA = `${NODE_URL}accounts/chart-of-accounts`;

//bulk assign in signup
export const BULK_ASSIGN = `${NODE_URL}company/bulk-assign`;

//export const COMPANY_DUPLICATE = `${BASE_URL}api/company/check_duplicate_company`;
export const COMPANY_DISPLAY = `${BASE_URL}api/company/check_display`;
export const CHARTS_OF_ACCOUNTS_DETAILS = `${BASE_URL}api/charts_of_accounts/account/details/`;
export const COMPANY_PROFILE_DETAIL = `${BASE_URL}api/company/get_company_details`;
export const COMPANY_BILLING_DETAIL = `${BASE_URL}api/company/get_billing_details`;
export const COMPANY_EDIT_ADDRESS = `${BASE_URL}api/company/get_edit_address_details`;
export const COMPANY_EDIT_CONTACT = `${BASE_URL}api/company/get_contact_details`;
export const DELETE_CONTACT_API = `${BASE_URL}api/company/delete_contact`;
export const COMMON_URL = `${NODE_URL}company/get_common`;

export const ADD_VENDOR = `${BASE_URL}api/vendors/add`;
export const ADD_UPDATE_CHART_OF_ACCOUNT_DETAILS = `${BASE_URL}api/charts_of_accounts/add_update_chart_of_account_details`;
export const COMPANY_PROFILE_PIC = `${BASE_URL}api/company/company_profile_pic/`;
export const CUSTOMER_GET_DATA = `${BASE_URL}api/customers/get/`;
export const CUSTOMER_GET_DATA_NEW = `${BASE_URL}api/customers/nfget/`;
export const CUSTOMER_GET_DATA_NODE = `${NODE_URL}customers/values/all`;
export const CUSTOMER_GET_DATA_NODE_TRACKING_PAGE = `${NODE_URL}customers/value/single`;
export const CUSTOMER_GET_HEADERS_NODE = `${NODE_URL}customers/get-header-configuration`;

export const ADD_UPDATE_CUSTOMER = `${BASE_URL}api/customers/add_update`;
export const ADD_CUSTOMER_DATA = `${NODE_URL}customers/new/create`;

export const CUSTOMERTABLE_VALUE_UPDATE_NODE = `${NODE_URL}customers/single/update-or-create`;

export const GET_CUST_COMMN = `${BASE_URL}api/customers/get_cust_commn`;
export const CUSTOMER_TABLEDROP_DATA = `${BASE_URL}api/customers/get_cust_commn_with_value`;
export const CUSTOMER_TABLEDYNAMIC_DROP = `${NODE_URL}customers/get_dynamic_field`;
export const CUSTOMER_TABLEDYNAMIC_DROP_NODE = `${NODE_URL}customers/options`;
export const CUSTOMER_PERSON_IN_TABLE = `${NODE_URL}user/get_persons/`;
export const CUSTOMER_ALL_PERSON_IN_ORG = `${NODE_URL}user/get_persons_all_inorg`;
export const RANDOM_PERSON = `${BASE_URL}api/random_persons`;
export const REPORTING_ADD_UPDATE = `${BASE_URL}api/customers/reporting/add_update`;
export const GET_REPORTING_DATA = `${BASE_URL}api/customers/reporting/views/`;
export const UPDATE_SAVE_OTHERDETAIL_DATA = `${BASE_URL}api/customers/add_update_single`;
export const CUSTOMER_SOCIAL_ADD_UPDATE = `${BASE_URL}api/customers/socials/add_update`;
export const CUSTOMER_CONTACT_ADD_UPDATE = `${BASE_URL}api/customers/contacts/add_update`;
export const GET_CUSTOMERLIST_HEADERS = `${BASE_URL}api/headers/get_header_configration`;
export const GET_HEADER_CONFIGURATION = `${NODE_URL}customers/get-header-configuration`;
export const DELETE_USER_CUSTOMERTABLE_REASONS_FETCH = `${NODE_URL}customers/get-customer-status-reasons-options`;
export const DELETE_OR_ARCHIVE_USER_CUSTOMERTABLE = `${NODE_URL}customers/update-customer-status`;
//export const DELETE_USER_CUSTOMERTABLE = `${NODE_URL}customers/get-header-configuration`;
export const POST_VIEW_CONFIGURATION = `${NODE_URL}customers/handle-view-creation`;
export const POST_FILTER_SAVE = `${NODE_URL}customers/view/update-meta`;
export const POST_FIELD_CREATION = `${NODE_URL}customers/field/create`;
export const POST_FIELD_UPDATE = `${NODE_URL}customers/field/update`;
export const POST_FIELD_DELETE = `${NODE_URL}customers/field/delete`;
export const POST_OPTION_DELETE = `${NODE_URL}customers/options/delete`;
export const POST_VIEW_DELETE = `${NODE_URL}customers/view/delete`;
export const CUSTOMERLIST_UPDATE_HEADERS = `${BASE_URL}api/headers/update_header_configration`;
export const CUSTOMERTABLE_VALUE_UPDATE = `${NODE_URL}customers/customer-list-single`;
export const CUSTOMERTABLE_ADDFIELD_HEADERS = `${BASE_URL}api/customers/add_optionla_field`;
export const CUSTOMERTABLE_UPDATEFIELD_HEADERS = `${BASE_URL}api/customers/update_optional_field`;
export const CUSTOMERTABLE_GETFIELD_HEADERS = `${BASE_URL}api/customers/get_additional_field`;
export const ADD_UPDATE_DROPDOWN = `${BASE_URL}api/customers/add_update_dropdown`;
export const DELETE_CUSTOMER_DATA = `${NODE_URL}customers/delete_customer_general_record`;
export const CUSTOMER_SERVICE_ADD_UPDATE = `${BASE_URL}api/customers/services/add_update`;
export const CUSTMOER_ARTIFACT_ADD_UPDATE = `${BASE_URL}api/customers/artifacts/add_update`;
export const CUSTOMER_ADRESSS_ADD_UPDATE = `${BASE_URL}api/customers/address/add_update`;
export const CUSTOMER_DELETE_DATA = `${BASE_URL}api/customers/socials/delete_social/`;
export const CUSTOMER_ADDRESS_DATA_GET = `${BASE_URL}api/customers/address/get_all_address/`;
export const CUSTOMER_SOCIAL_DATA_GET = `${BASE_URL}api/customers/socials/get_all_links/`;
export const CUSTOMER_REPORTING_DATA_GET = `${BASE_URL}api/customers/reporting/views/`;
export const CUSTOMER_CONTACT_DATA_GET = `${BASE_URL}api/customers/contacts/get_all_contacts/`;
// export const CUSTOMER_SERVICE_DATA_GET = `${BASE_URL}api/customers/services/get_all_services/`;
// export const CUSTOMER_SERVICE_DATA_GET = `${NODE_URL}customers/get-all-services`;
export const CUSTOMER_SERVICE_DATA_GET = `${NODE_URL}customers/get-customer-services`;
export const DELETE_SERVICE_DATA = `${NODE_URL}customers/delete-service`;
export const ALL_SERVICE = `${NODE_URL}customers/get-all-services`;
export const ADD_UPDATE_ORG_SERVICE = `${NODE_URL}org/add-update-service-list`;
export const CUSTMOER_ARTIFACT_DATA_GET = `${BASE_URL}api/customers/artifacts/get_artifacts/`;
export const CUSTOMER_REPORTING_DELETE = `${BASE_URL}api/customers/reporting/delete_reporting/`;
export const CUSTOMER_SOCIAL_DATA_DELETE = `${BASE_URL}api/customers/socials/delete_social/`;
export const CUSTOMER_SERVICE_DATA_DELETE = `${BASE_URL}api/customers/services/delete_contact/`;
export const CUSTOMER_NOTES_ADD_UPDATE = `${NODE_URL}customers/notes/add_update`;
export const CUSTMOER_NOTES_DATA_GET = `${NODE_URL}customers/notes/fetch_notes/`;
export const CUSTMOER_NOTES_ATTACHMENT_DATA_GET = `${BASE_URL}api/customers/notes/delete_attachment/`;
export const CUSTMOER_NOTES_DATA_DELETE = `${NODE_URL}customers/notes/delete_notes/`;
export const CUSTOMER_ADDRESS_DATA_DELETE = `${BASE_URL}api/customers/address/delete_address/`;
export const CUSTOMER_ADD_NOTES_ATTACHMENT = `${NODE_URL}customers/notes/attachments`;
export const CUSTOMER_DELETE_NOTES_ATTACHMENT = `${NODE_URL}customers/notes/attachments/`;
//export const CUSTOMER_DETAILS_DATA = `${BASE_URL}api/customers/customer_details/`;
export const CUSTOMER_DETAILS_DATA = `${NODE_URL}customers/customer_details/`;
export const CUSTOMER_OTHER_DETAILS = `${BASE_URL}api/customers/get_others_details/`;
export const CUSTOMER_ARTIFACT_DATA_DELETE = `${BASE_URL}api/customers/artifacts/delete_artifact/`;
export const CUSTOMER_CONTACT_DATA_DELETE = `${BASE_URL}api/customers/contacts/delete_contact/`;
export const CUSTOMER_OTHERDETAIL_DYNAMIC_ADD_UPDATE = `${BASE_URL}api/customers/add_others_lable`;
export const CUSTOMER_TASK_CATEGORY = `${BASE_URL}api/customers/tasks/get_common_cat`;
export const CUSTOMER_COMMON_DATA = `${NODE_URL}org/get-common`;
export const CUSTOMER_TASK_PROJECT_CATEGORY = `${NODE_URL}task/project/enum-values`;

export const CUSTOMER_REPORTING_STATUS = `${BASE_URL}api/customers/reporting/status`;
export const CUSTOMER_SOCAIL_LINK_STATUS = `${BASE_URL}api/customers/socials/status`;
export const CUSTOMER_ARTIFACT_STATUS = `$get_task{BASE_URL}api/customers/artifacts/status`;
export const CUSTOMER_CONTACT_STATUS = `${BASE_URL}api/customers/contacts/status`;
export const CUSTOMER_SERVICE_STATUS = `${BASE_URL}api/customers/services/status`;
export const CUSTOMER_TASK_ADD_UPDATE = `${NODE_URL}customers/tasks/add_update`;
export const CUSTOMER_TASK_DATA_GET = `${BASE_URL}api/customers/tasks/get_task/`;
export const TASK_GET_ORGACCORDING = `${BASE_URL}api/customers/tasks/get_task_org`;

export const CUSTOMER_NOTES_COLOR_CODE = `${NODE_URL}customers/get_colours`;
export const CUSTOMER_MANAGER_LIST = `${BASE_URL}api/customers/reporting/manger`;
export const CUSTOMER_ARTIFACT_DATATYPE = `${NODE_URL}customers/artifacts/get_doc_type`;
export const CUSTOMER_GROUP_LIST = `${BASE_URL}api/customers/get_customer_group`;
export const ADD_UPDATE_GROUP = `${NODE_URL}customers/group/create-update`;
export const CUSTOMER_DESINATION_LIST = `${BASE_URL}api/customers/reporting/designations`;
export const CUSTOMER_GET_USER_DATA = `${NODE_URL}user/get_persons`;
export const CUSTOMER_CLOSED_TASK_GET = `${BASE_URL}api/customers/tasks/get_close_task/`;
export const CUSTOMER_OVERDUSE_TASK_GET = `${BASE_URL}api/customers/tasks/get_overdue_task/`;
export const CUSTOMER_ACTIVITY_ADD_UPDATE = `${BASE_URL}api/customers/tasks/add_update_task_activity`;
//export const CUSTOMER_ACTIVITY_GET_EVENT = `${BASE_URL}api/customers/tasks/get_task_activity`;
export const CUSTOMER_ACTIVITY_GET_EVENT = `${NODE_URL}get-activity`;
export const CUSTOMER_ACTIVITY_ADD_EVENT = `${NODE_URL}add-update-activity`;

export const CUSTOMER_ADD_TEAM = `${NODE_URL}customers/add-update-team`; //VINAY
export const CUSTOMER_TEAM_ROLES = `${NODE_URL}customers/add-update-team-role`; //VINAY
export const CUSTOMER_TEAM_SKILL_LEVELS = `${NODE_URL}customers/add-update-skill-level`; //VINAY
export const CUSTOMER_TEAM_ALL_GET_DATA = `${NODE_URL}customers/fetch-team-data`; //VINAY

export const CUSTOMER_TASK_POD_DATA = `${BASE_URL}api/customers/tasks/get_task_pod`;
export const VENDOR_HEADER_LIST = `${NODE_URL}accounts/vouchers`;
export const TASKPOD_ADD_UPDATE = `${BASE_URL}api/customers/tasks/add_update_task_pod`;
export const TASK_VIEW_DATA = `${BASE_URL}api/customers/tasks/get_task_by/`;
export const CUSTOMER_SERVICE_CATEGORY = `${BASE_URL}api/customers/services/service_dropdown`;
export const CUSTOMER_SOCIAL_CATEGORY = `${NODE_URL}customers/socials/get_social_link_dp`;
export const CUSTOMERTABLE_TASK_VALUE_UPDATE = `${BASE_URL}api/customers/tasks/add_update_single_task`;
export const UPDATE_TASK_COMPLETION = `${NODE_URL}customer-tasks/update-columns`;
export const CUSTOMER_SINGLE_UPDATE_CONTACT_PERSON = `${BASE_URL}api/customers/contacts/add_update_single_contact`;
// export const CUSTOMER_TASK_GET_TASKPOD = `${BASE_URL}api/customers/tasks/get_task_pod_details/`;
export const CUSTOMER_TASK_GET_TASKPOD = `${NODE_URL}task/get-all-tasks`;
export const CUSTOMER_TASK_HEADER_CONFIG = `${NODE_URL}task/metadata`;
export const GET_LINKED_TASKS = `${NODE_URL}company/link/get`;
export const LINK_TASKS = `${NODE_URL}company/link/create`;
export const UNLINK_TASKS = `${NODE_URL}company/link/remove`;
export const CUSTOMER_TASK_DELETE = `${NODE_URL}task`;
export const CUSTOMER_PROJECT_DELETE = `${NODE_URL}projects`;
export const CUSTOMER_TASK_GET_ALL_CUSTOMER = `${NODE_URL}task/accessible`;

export const ADD_UPDATE_CUSTOMER_SERVICE = `${NODE_URL}customers/add-update-customer-service`;
// MY SPACE API
export const MY_SPACE_CONTAINER = `${NODE_URL}myspace/fetch-my-container`;
export const MY_SPACE_HEADER_CONFIG = `${NODE_URL}myspace/get-header-configuration`;
export const MY_SPACE_DATA = `${NODE_URL}myspace/fetch/:containerId`;
export const MY_SPACE_ADD_FIELD = `${NODE_URL}myspace/add-field`;
export const MY_SPACE_ADD_FIELD_VALUE = `${NODE_URL}myspace/add-update-field-value`;
// export const MY_SPACE_FIELD_OPTIONS = `${NODE_URL}myspace/field-options/:columnId`;
export const MY_SPACE_ADD_UPDATE_CONTAINER = `${NODE_URL}myspace/create-update-container`;

//funnel related apis

export const GET_FUNNEL_TYPES = `${NODE_URL}task/funnel`;
export const POST_FUNNEL_TYPES = `${NODE_URL}task`;
export const STAGE_LINKED_TASK = `${NODE_URL}task/funnel-task-link`;

export const MY_SPACE_GET_FOLDER = `${NODE_URL}myspace/folders`;
export const MY_SPACE_ADD_LIST = `${NODE_URL}myspace/tables`;
export const MY_SPACE_UPLOAD_FILE = `${NODE_URL}myspace/upload`;
export const MY_SPACE_GET_TABLE_HEADERS = `${NODE_URL}myspace/tables/:tableId/fields`;
export const MY_SPACE_GET_TABLE_BODY = `${NODE_URL}myspace/tables/:tableId`;
export const MY_SPACE_ADD_UPDATE_TABLE_CELL = `${NODE_URL}myspace/tables/:tableId`;
export const MY_SPACE_ADD_TABLE_COLUMN = `${NODE_URL}myspace/tables/:tableId/fields`;
export const MY_SPACE_ADD_TABLE_COLUMN_OPTIONS = `${NODE_URL}myspace/fields/:tableColumnId/options`;
export const MY_SPACE_RENAME_AND_MOVE_FOLDER_FILE = `${NODE_URL}myspace/folders/:folder-file-id`;
export const MY_SPACE_CSV_UPLOAD = `${NODE_URL}myspace/tables/upload-csv`;
export const MY_SPACE_DELETE_FILE_FOLDER = `${NODE_URL}myspace/:folder-file-id`;
export const MY_SPACE_FIELD_OPTIONS = `${NODE_URL}myspace/fields/:fieldId/options`;
export const MY_SPACE_UPDATE_TABLE_COLUMN_NAME = `${NODE_URL}myspace/tables/:tableId/fields/:fieldId`;
export const MY_SPACE_DELETE_ROW_LIST_DATA = `${NODE_URL}myspace/tables/:tableId/rows/delete`;
export const MY_SPACE_BULK_UPDATE_LIST = `${NODE_URL}myspace/tables/:tableId`;
export const MY_SPACE_BULK_DELETE_COLUMN = `${NODE_URL}myspace/tables/:tableId/columns/delete`;
export const MY_SPACE_ROW_EDIT = `${NODE_URL}myspace/tables/:tableId/multiple`;
export const MY_SPACE_SEND_ACCESS = `${NODE_URL}myspace/share`;
export const MY_SPACE_GET_USER_ACCESS = `${NODE_URL}myspace/access/:containerId`;
export const MY_SPACE_UPDATE_USER_ACCESS = `${NODE_URL}myspace/access/:containerId`;
export const MY_SPACE_REMOVE_USER_ACCESS = `${NODE_URL}myspace/access/:containerId`;
export const MY_SPACE_SHARED_FILE_FOLDER = `${NODE_URL}myspace/shared`;
export const MY_SPACE_DELETE_OPTION = `${NODE_URL}myspace/fields/:fieldId/options/:optionId`;
export const MY_SPACE_PERSON_LIST = `${NODE_URL}user/get_persons/:companyId`;
export const MY_SPACE_GET_PINNED_LIST = `${NODE_URL}myspace/pin`;
export const MY_SPACE_MARKED_AS_PINNED = `${NODE_URL}myspace/pin`;
export const MY_SPACE_MARKED_AS_UNPINNED = `${NODE_URL}myspace/unpin`;

export const CUSTOMER_SERVICE_SINGLE_UPDATE = `${BASE_URL}api/customers/services/add_update_single_service`;
export const CUSTOMER_ARTIFACT_SINGLE_UPDATE = `${BASE_URL}api/customers/artifacts/add_update_single_artifact`;
export const GET_COMPANY_ADDRRESS = `${BASE_URL}api/company/get_edit_address_details/`;
export const SINGLE_UPDATE_SOCIAL_LINK = `${BASE_URL}api/customers/socials/add_update_single_social`;
export const SINGLE_UPDATE_REPORTING_TEAM = `${BASE_URL}api/customers/reporting/add_update_single_reporting`;
export const CUSTOMER_ALL_ADDRESS = `${BASE_URL}api/customers/address/get_all_customer_address/`;
export const DELETE_CUSTOMER_ALL_ADDRESS = `${BASE_URL}api/customers/delete_customer_address`;
export const CUSTOMER_TASK_HEADER = `${BASE_URL}api/customers/tasks/get_task_headers`;
export const CUSTOMER_ADDRESS_SINGLE_GET = `${BASE_URL}api/customers/address/get_edit_address/`;
export const CUSTOMER_All_NOTES_BASED_SCROLL = `${BASE_URL}api/customers/notes/notes/fetch_all_notes/`;
export const CUSTOMER_EDIT_TASK_DATA = `${BASE_URL}api/customers/tasks/get_task_edit/`;
export const CUSTOMER_GET_ALL_NOTES_DATA_BASEDON_SCROLL = `${BASE_URL}api/customers/notes/fetch_all_notes/`;
export const CUSTOMER_GET_ALL_ACTIVITY_DATA_BASED_ON_SCROLL = `${BASE_URL}api/customers/tasks/get_all_task_activity/`;
// export const ADD_UPDATE_USER_LIST = `${BASE_URL}api/users/add_edit_user`;
//export const MANAGE_LIST_GET = `${BASE_URL}api/users/get_manage_list`;
export const GET_MANAGE_LIST = `${NODE_URL}manage/manage-list`;
export const POST_ADD_UPDATE_MANAGE_LIST = `${NODE_URL}manage/manage-list`;
export const DELETE_MANAGE_LIST = `${NODE_URL}manage/manage-list`;
export const GET_HEADERS_BY_ROW_ID_MANAGE_FIELDS = `${NODE_URL}manage/field-table`;
export const GET_VALUES_BY_ROW_ID_MANAGE_FIELDS = `${NODE_URL}manage/value-table`;
export const POST_ADD_FIELD_MANAGE_FIELDS = `${NODE_URL}manage/field-table`;
export const POST_ADD_VALUE_MANAGE_FIELDS = `${NODE_URL}manage/value-table`;
export const DELETE_ROW_VALUE = `${NODE_URL}manage/value-table`;
export const DELETE_COLUMN_FIELDS = `${NODE_URL}manage/field-table`;

//export const DYNAMIC_LIST_DATA = `${BASE_URL}api/users/get_dynamic_value_list/`;
export const DYNAMIC_LIST_DATA = `${NODE_URL}manage/get-dynamic-value-list`;
export const DYNAMIC_HEADER_LIST = `${BASE_URL}api/users/get_dynamic_header_value/`;
export const EDITE_DYNAMIC_VALUE = `${BASE_URL}api/users/get_dynamic_table_edit_value/`;
//export const ADD_UPDATE_DYANMIC_TABLE = `${BASE_URL}api/users/add_update_dynamic_table`;
// export const ADD_UPDATE_DYANMIC_TABLE = `${NODE_URL}manage/add-update-dynamic-value-list`;
export const GET_ALL_DATA_RELETED_TO_DESIGNATION = `${NODE_URL}users/all_data_related`;
export const GET_MANAGE_PERMISSION = `${BASE_URL}api/org/org_groups_get`;
export const GET_MANAGE_GROUPS = `${BASE_URL}api/org/org_groups_people`;
export const SELECT_PERMISSION_LEVEL = `${BASE_URL}api/permission/permission_list`;
export const PERMISSION_MODULES = `${BASE_URL}api/permission/permission_modules`;
export const PERMISSION_ADDUPDATE = `${BASE_URL}api/permission/addupdate_permission`;
export const SELECT_COMPANY_PERMISSION_LEVEL = `${BASE_URL}api/permission/company_permission_list`;
//export const GET_PERMISSION_COMPANY_MODULE =`${BASE_URL}api/permission/company_permission_modules`;
export const GET_PERMISSION_COMPANY_MODULE = `${BASE_URL}api/org/permission_modules_company`;
export const ADD_UPDATE_PERMISSION_COMPANY = `${BASE_URL}api/permission/add_update_permision_company`;
export const GET_PERMISSION_COMPANY = `${NODE_URL}permission/get_company_permission`;
export const ADDUPDATE_ORG = `${BASE_URL}api/org/addupdate_org`;

export const ENUM_VALUE_GET = `${BASE_URL}api/field/enumvalueget`;

export const ADDUPDATE_ORG_MEMBER = `${BASE_URL}api/org/addupdate_org_member`;
// export const EDIT_USER_LIST_BASED_ON_ID = `${BASE_URL}api/users/get_user_edit/`;
export const GET_COMPANY_DELEGETION = `${NODE_URL}get_company_delegation`;
export const GET_COMPANY_DELEGATION_NEW = `${NODE_URL}customers/delegation`;
export const UPDATE_COMPANY_ADDRESS = `${BASE_URL}api/company/update_address`;
export const ADD_COMPANY_GROUP = `${BASE_URL}api/company/add_company_group`;
export const ADD_UPDATE_DELEGATION = `${NODE_URL}manager_access/add_access`;
export const DELETE_ACCESS = `${NODE_URL}manager_access/delete_access`;
export const GET_DELEGATION_DATA_EDITE = `${BASE_URL}api/manager_access/get_delegation/`;
export const GET_ORGANIZATION_EDIT_DATA = `${BASE_URL}api/org/get_organization_edit/`;
export const DELETE_ORGANIZATION_DATA = `${BASE_URL}api/org/delete_organization/`;
export const GET_COMPANY_GROUP = `${NODE_URL}api/org/company_groups_get/`;
export const GET_COMPANY_GROUP_PEOPLE = `${BASE_URL}api/org/company_groups_people`;
export const ADD_UPDATE_COMPANY_GROUP = `${BASE_URL}api/org/addupdate_company`;
export const ADD_UPDATE_MEMBER_COMPANY = `${BASE_URL}api/org/addupdate_member_company`;
export const GET_CUSTOMER_DELEGATION = `${BASE_URL}api/customers/get_customer_delegation/`;
export const CHECK_EMAIL_DUPLICATE = `${NODE_URL}check_duplicate_email`;
export const DELTE_COMPANY_DELEGATION = `${BASE_URL}api/company/delete_delegation/`;
export const ADD_UPDATE_CUSTOMER_DELEGATION = `${BASE_URL}api/customers/add_update_customer_delegation`;
export const ADD_CUSTOMER_DELEGATION = `${NODE_URL}customers/add_customer_delegation`;
export const DELETE_UPDATE_CUSTOMER_DELEGATION = `${NODE_URL}customers/delete_customer_delegation`;
export const GET_ALL_CUSTOMER_DELEGATION = `${BASE_URL}api/customers/get_all_customer_delegation/`;
export const GET_ALL_CUSTOMER_DELEGATION_RIGHT = `${BASE_URL}api/manager_access/get_customer_delegation_access`;
export const CUST_DELEGATION = `${BASE_URL}api/customers/get_delegation/`;
export const DELETE_CUSTOMER_DELEGATION = `${BASE_URL}api/customers/delete_delegation/`;
export const GET_COMPANY_DEFAULT_ADDRESS = `${BASE_URL}api/company/get_company_default_addrees/`;
export const ADD_UPDATE_COMPANY_ADDRESS = `${BASE_URL}api/company/add_Update_company_address`;
export const GET_ALL_ADDRESS_COMPANY = `${BASE_URL}api/company/get_all_company_address/`;
export const EDIT_COMPANY_ADDRESS_BASED_ON_ID = `${BASE_URL}api/company/get_edit_company_address/`;
export const ADD_UPDATE_VENDOR = `${BASE_URL}api/vendors/add_update`;
export const GET_VENDOR_LIST = `${BASE_URL}api/vendors/get_vendors_list/`;
export const EDIT_VENDOR_DATA = `${BASE_URL}api/vendors/edit_vendors/`;
export const ADD_VENDOR_SOCAIL_LINK = `${BASE_URL}api/vendors/links/add_socail_link`;
export const GET_SOCIAL_LINK_VENDOR = `${BASE_URL}api/vendors/links/get_socail_link/`;
export const DELETE_SOCAIL_Vendor_LINK = `${BASE_URL}api/vendors/links/delete_socail_link/`;
export const ADD_VENDOR_CONATACT_PERSON = `${BASE_URL}api/vendors/contact/add_update`;
export const DELETE_VENDOR_CONTACT_DATA = `${BASE_URL}api/vendors/contact/delete_contact/`;
export const GET_VENDOR_CONTACT_DATA = `${BASE_URL}api/vendors/contact/get_contact_list/`;
export const SINGLE_VENDOR_ADD_UPDATE_CONTACT_DATA = `${BASE_URL}api/vendors/contact/add_update_single_contact/`;
export const ADD_UPDATE_VENDOR_ADDRESS = `${BASE_URL}api/vendors/address/add_update`;
export const GET_VENDOR_ALL_ADDRESS = `${BASE_URL}api/vendors/address/get_all_Address/`;
export const GET_VENDOR_DEFAULT_ADDRESS = `${BASE_URL}api/vendors/address/get_default_Address/`;
export const EDIT_VENDOR_ADDRESS = `${BASE_URL}api/vendors/address/get_edit_Address/`;
export const EDIT_VENDOR_DATA_LIST = `${BASE_URL}api/vendors/get_edit_vendor_data_list/`;
export const EDIT_VENDOR_SOCIAL_DATA = `${BASE_URL}api/vendors/links/get_socail_link_edit/`;
export const CUSTOMER_DEPARTMENT_LIST = `${BASE_URL}api/customers/reporting/departments`;
export const MANAGE_ACCESS_DELETEGATION = `${BASE_URL}api/manager_access/get_delegation_access`;
export const GET_CUSTOMER_ACCESS_AVAILABLE = `${BASE_URL}api/customers/get_customer_delegation_access/`;
export const CHECK_ORG_DUPLICATE = `${NODE_URL}check_duplicate_org`;
export const CHECK_IS_OWNER = `${NODE_URL}customers/check-owner`;
export const GET_USER_DETAILS_MORE_DETAILS = `${NODE_URL}user/get-manager-team`;
export const GET_CUSTOMER_GROUP_DATA_ADD_UPDATE_TIME = `${BASE_URL}api/customers/get_customer_groups`;
export const GET_CUSTOMER_GROUP_DATA_ADD_UPDATE_TIME1 = `${NODE_URL}customers/get-groups`;

export const DELETE_TABLE_CATEGORIES_DATA = `${BASE_URL}api/mange_list/delete`;
export const DELETE_EXTERNAL_USER = `${BASE_URL}api/external/delete`;
export const CHECK_DUPLICATE_CUSTOMER = `${NODE_URL}customers/check_duplicate_customer`;
export const CHECK_DUPLICATE_CUST_DISP_NAME = `${BASE_URL}api/customers/check_duplicate_customer_display_name`;
// export const GET_GROUP_DATA = `${BASE_URL}api/users/get_org_group`;
export const GET_GROUP_DATA = `${NODE_URL}org/org-groups-get`;
export const GET_PERMISSION_DATA = `${NODE_URL}permission/company-permissions`;
export const GET_USERS_IN_GROUP = `${NODE_URL}permission/get-group-members`;
// export const GET_TASK_NOTIFICATION = `${NODE_URL}task/get_tasks_notification`;
export const GET_ALL_NOTIFICATIONS = `${NODE_URL}notifications?page=1&limit=100`;
export const MARK_ALL_NOTIFICATION_AS_READ = `${NODE_URL}notifications/mark-all-read`;
export const MARK_SINGLE_NOTIFICATION_AS_READ = `${NODE_URL}notifications/mark-read`;
export const CREATE_FOLDER = `${NODE_URL}documents/create-folder`;
export const UPLOAD_FILE = `${NODE_URL}documents/upload`;
export const GET_FOLDER = `${NODE_URL}documents/get-folders`;
export const MOVE_FOLDER = `${NODE_URL}documents/`;
export const MOVE_FILE = `${NODE_URL}documents/document/`;
export const DELETE_FOLDER = `${NODE_URL}documents/folders/<ID>`;
export const DELETE_FILE = `${NODE_URL}documents/documents/<ID>`;
export const VENDOR_VOUCHER_TYPES = `${NODE_URL}accounts/vouchers/types`;
export const VENDOR_VOUCHER_CREATE = `${NODE_URL}accounts/vouchers/create`;
export const ADD_UPDATE_USER_LIST = `${NODE_URL}user/create-update-user`;
export const GET_ALL_TASKPODS = `${NODE_URL}customers/get-pods`;
export const CREATE_PODS = `${NODE_URL}customers/create-pods`;
export const USER_LIST_DATA = `${NODE_URL}user/get-all-user`;
export const ENABLE_USER = `${NODE_URL}user/toggle-user-status`;
export const EDIT_USER_LIST_BASED_ON_ID = `${NODE_URL}user/get_user_edit`;
export const UPDATE_CUSTOMER_DATA = `${NODE_URL}customers/add-update-customer-general-record`;
export const GET_ALL_ORG_SERVICE = `${NODE_URL}org/get-all-services-list`;
export const ADD_UPDATE_TEAM = `${NODE_URL}customers/add-update-team`;
export const ADD_UPDATE_TEAM_MEMBER = `${NODE_URL}customers/add-update-team-member`;
export const GET_ALL_PROJECTS = `${NODE_URL}project/fetch/all`;
export const CREATE_PROJECT = `${NODE_URL}projects/create-update`;
export const CREATE_UPDATE_PROJECTS = `${NODE_URL}projects/create-update`;
export const GET_SINGLE_PROJECT = `${NODE_URL}project/fetch`;
export const CREATE_PROJECT_JOB = `${NODE_URL}customers/tasks/add_update`;
export const LINK_TASK_TO_NOTES = `${NODE_URL}task/linkTaskToNotes`;
export const GET_PROJECT_TASK_ENUM_VALUES = `${NODE_URL}project/task/enum`;
export const GET_TASK_TAGS = `${NODE_URL}task/tags`;
export const GET_ALL_SERVICES = `${NODE_URL}org/get-all-services-list`;
export const DELETE_SUB_SERVICE = `${NODE_URL}org/delete-sub-service`;
export const GET_COMPANY_LIST_GROUPS = `${NODE_URL}org/get-company-list-groups`;

export const MANAGE_PERMISSIONS_FETCH_DATA = `${NODE_URL}company/permission/fetch`;
export const MANAGE_PERMISSIONS_ADD_UPDATE_PERMISSION = `${NODE_URL}company/permission/add-update`;
export const MANAGE_PERMISSIONS_ADD_UPDATE_GROUP = `${NODE_URL}company/cpl-group/add-update`;
export const MANAGE_PERMISSIONS_GRANT_PERMISSION = `${NODE_URL}company/cplg-members/add-update`;
export const MANAGE_PERMISSIONS_DELETE_GROUP = `${NODE_URL}company/delete-group`;
export const MANAGE_PERMISSIONS_DELETE_PERMISSION = `${NODE_URL}company/delete-permission`;
export const MANAGE_PERMISSION_ADD_GROUP_PERMISSION_MEMBER = `${NODE_URL}company/groups/add-members`;
export const MANAGE_PERMISSION_DELETE_GROUP_PERMISSION_MEMBER = `${NODE_URL}company/delete-group-member`;
export const MANAGE_PERMISSIONS_ADD_UPDATE_GROUP_PERMISSION = `${NODE_URL}company/group-permission/add-update`;

//for company & company section & Fields
export const COMPANY_PROFILE_BASIS_OF_USER_LOGIN = `${NODE_URL}company/get-company-profile`; //get all company's
export const COMPANY_HEADER = `${NODE_URL}company-form/get-company-headers?page=`; //get the header
export const COMPANY_ADD = `${NODE_URL}company-form/create-new-company`; // add new company
export const GET_VALUE = `${NODE_URL}company-form/get-form-data?company_id=`; // gett the post value
export const UPDATE_SECTION_FIELD = `${NODE_URL}company-form/update-form-fields?page=`; //upadate the selection of field
export const MANAGE_PERMISSIONS_DELETE_GROUP_MEMBER = `${NODE_URL}company/delete-group-member`;
export const VENDOR_REST_API = `${NODE_URL}vendor`;
export const GET_DROPDOWN_GROUPS_AND_VALUES = `${NODE_URL}dropdown`;

//For Template and section
export const GET_ALL_SECTIONS = `${NODE_URL}template/sections`;
export const GET_SECTION_FILEDS = `${NODE_URL}template/section/header-fields`;
export const GET_FIELD_VALUE = `${NODE_URL}template/fetch-dropdown?field_name=`;
export const GET_NOTES_TAGS = `${NODE_URL}global/dropdown/tags/notes`;
export const GET_ALL_TEMPLATE = `${NODE_URL}template`;
export const GET_ALL_LINKED_SECTIONS = `${NODE_URL}template`;
export const DELETE_LINKED_SECTION = `${NODE_URL}template/unlink-section`;
export const GET_LINKED_SECTIONS_FIELDS = `${NODE_URL}template/header-config`;
export const GET_ALL_TASKS = `${NODE_URL}template/get-all-task`;
export const DELETE_SECTION = `${NODE_URL}template/section/delete`;
export const DELETE_TEMPLATE = `${NODE_URL}template/delete`;
export const DELETE_FIELD = `${NODE_URL}template/section/field/delete`;
export const GET_SECTION_AND_FIELDS = `${NODE_URL}template/fetch/layout`;
export const TASK_LINKING = `${NODE_URL}task/resources?taskID=`;

// Custom TEMPLATES
export const CUSTOM_CREATE_TEMPLATE = `${NODE_URL_V2}global/template`;
export const CUSTOM_TEMPLATES_GET_TEMPLATE_DETAILS = `${NODE_URL_V2}global/template-details/:template_id`;
export const CUSTOM_TEMPLATES_UPDATE_TEMPLATE_DETAILS = `${NODE_URL_V2}global/template`;
export const CUSTOM_TEMPLATES_ADD_SECTION = `${NODE_URL_V2}global/section`;
export const CUSTOM_TEMPLATES_UPDATE_SECTION = `${NODE_URL_V2}global/section`;
export const CUSTOM_TEMPLATES_ADD_INPUT = `${NODE_URL_V2}global/field?key=u2_core`;
export const CUSTOM_TEMPLATES_UPDATE_INPUT = `${NODE_URL_V2}global/field?key=u2_core`;
export const CUSTOM_TEMPLATES_DELETE_TEMPLATE = `${NODE_URL_V2}global/template/:template_id`;
export const CUSTOM_TEMPLATES_DELETE_SECTION = `${NODE_URL_V2}global/section/:section_id`;
export const CUSTOM_TEMPLATES_DELETE_INPUT = `${NODE_URL_V2}global/field-raw/:field_id?key=u2_core`;
export const CUSTOM_TEMPLATES_GET_CREATE_UPDATE_OPTIONS = `${NODE_URL}dropdown/values`;
export const CUSTOM_TEMPLATES_DELETE_OPTION = `${NODE_URL}dropdown/dropdown-value/:id`;
export const CUSTOM_TEMPLATES_DEPLOY_TEMPLATE = `${NODE_URL_V2}global/deploy-template`;

export const GET_VENDOR_HEADER_CONFIGURATION = `${NODE_URL}vendor/header-configuration`;
export const GET_VENDOR_HEADER_CONFIGURATION_VALUES = `${NODE_URL}vendor/header-configuration-values`;

export const BILLING_GET_HEADER = `${NODE_URL}global/header-configuration?key=customer_billing`;
export const BILLING_GET_HEADER_VALUES = `${NODE_URL}global/header-configuration-values?key=customer_billing`;
export const BILLING_ADD_UPDATE_HEADER = `${NODE_URL}global/field?key=customer_billing`;
export const BILLING_ADD_UPDATE_FIELD_VALUE = `${NODE_URL}global/value?key=customer_billing`;
export const BILLING_GET_COLUMN_DROPDOWN_OPTIONS = `${NODE_URL}dropdown/values`;
export const BILLING_DELETE_COLUMN_OPTION = `${NODE_URL}dropdown/dropdown-value/:optionId`;
export const BILLING_ADD_UPDATE_BILLING_OPTION = `${NODE_URL}dropdown/values`;
export const BILLING_DELETE_FIELD_OPTION = `${NODE_URL}dropdown/dropdown-value/:optionId`;
export const BILLING_DELETE_COLUMN = `${NODE_URL}global/field/:fieldId?key=customer_billing`;
export const BILLING_DELETE_ROW = `${NODE_URL}global/value/:rowId?key=customer_billing`;
export const BILLING_ADD_UPDATE_ROW = `${NODE_URL}global/value-bulk?key=customer_billing`;

// -----------------------------------CUSTOM MODULE-----------------------------------
export const CUSTOM_MODULE_GET_HEADER = `${NODE_URL_V2}global/header-configuration`;
export const CUSTOM_MODULE_GET_HEADER_VALUES = `${NODE_URL_V2}global/header-configuration-values`;
export const CUSTOM_MODULE_ADD_UPDATE_HEADER = `${NODE_URL_V2}global/field?key=u2_core`;
export const CUSTOM_MODULE_ADD_UPDATE_FIELD_VALUE = `${NODE_URL_V2}global/value`;
export const CUSTOM_MODULE_GET_COLUMN_DROPDOWN_OPTIONS = `${NODE_URL}dropdown/values`;
export const CUSTOM_MODULE_DELETE_COLUMN_OPTION = `${NODE_URL_V2}dropdown/dropdown-value/:optionId`;
export const CUSTOM_MODULE_ADD_UPDATE_CUSTOM_MODULE_OPTION = `${NODE_URL}dropdown/values`;
export const CUSTOM_MODULE_DELETE_FIELD_OPTION = `${NODE_URL_V2}dropdown/dropdown-value/:optionId`;
export const CUSTOM_MODULE_DELETE_COLUMN = `${NODE_URL_V2}global/field/:fieldId?key=u2_core`;
export const CUSTOM_MODULE_DELETE_ROW = `${NODE_URL_V2}global/value/:rowId`;
export const CUSTOM_MODULE_ADD_UPDATE_ROW = `${NODE_URL_V2}global/value-bulk`;
// -----------------------------------CUSTOM MODULE-----------------------------------

// NEW USER MANAGEMENT API
export const CREATE_OR_UPDATE_USER = `${NODE_URL}company/user/create-or-update`;
export const DELETE_USER = `${NODE_URL}company/delete-user`;

export const GET_ALL_MODULESANDTASK = `${NODE_URL_V2}global/template`;

//---------------------------Activity Logs--------------------------------------
export const GET_ACTIVITY_LOG = `${NODE_URL}audit/logs`;
export const GET_ALL_EVENTS = `${NODE_URL}audit/events`;
export const GET_COMPARISON_LOG = `${NODE_URL}audit`;
export const USER_PREFERENCE = `${NODE_URL}generic-meta`;

export const GET_GLOBAL_LIST = `${NODE_URL}global/dropdown/all`;
export const ADD_UPDATE_GLOBAL_LIST = `${NODE_URL}global/dropdown`;
export const GET_ALL_TAGS = `${NODE_URL}global/dropdown/tags/all`;

// -----------------------------Customer Dashboard-----------------------------
export const GET_CUS_DASH_DATA = `${NODE_URL}customer/dashboard?customer_id=`;

// ------------------------Company Dashboard------------------------
export const GET_COMPANY_DASH_DATA = `${NODE_URL}company/dashboard`;
